export const FETCH_PARTNER_BY_ID_REQUEST = 'FETCH_PARTNER_BY_ID_REQUEST';
export const FETCH_PARTNER_BY_ID_SUCCESS = 'FETCH_PARTNER_BY_ID_SUCCESS';
export const FETCH_PARTNER_BY_ID_FAILED = 'FETCH_PARTNER_BY_ID_FAILED';

export const FETCH_PARTNERS_REQUEST = 'FETCH_PARTNERS_REQUEST';
export const FETCH_PARTNERS_SUCCESS = 'FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILED = 'FETCH_PARTNERS_FAILED';

export const FETCH_INVITE_PARTNER_REQUEST = 'FETCH_INVITE_PARTNER_REQUEST';
export const FETCH_INVITE_PARTNER_SUCCESS = 'FETCH_INVITE_PARTNER_SUCCESS';
export const FETCH_INVITE_PARTNER_FAILED = 'FETCH_INVITE_PARTNER_FAILED';

export const REMOVE_PARTNER_INVITE_REQUEST = 'REMOVE_PARTNER_INVITE_REQUEST';
export const REMOVE_PARTNER_INVITE_SUCCESS = 'REMOVE_PARTNER_INVITE_SUCCESS';
export const REMOVE_PARTNER_INVITE_FAILED = 'REMOVE_PARTNER_INVITE_FAILED';

export const UPDATE_PARTNER_STATE_REQUEST = 'UPDATE_PARTNER_STATE_REQUEST';
export const UPDATE_PARTNER_STATE_SUCCESS = 'UPDATE_PARTNER_STATE_SUCCESS';
export const UPDATE_PARTNER_STATE_FAILED = 'UPDATE_PARTNER_STATE_FAILED';

export const FETCH_INVITES_REQUEST = 'FETCH_INVITES_REQUEST';
export const FETCH_INVITES_SUCCESS = 'FETCH_INVITES_SUCCESS';
export const FETCH_INVITES_FAILED = 'FETCH_INVITES_FAILED';

export const RESET_PARTNER = 'RESET_PARTNER';
export const RESET_PARTNERS_DATA = 'RESET_PARTNERS_DATA';
